import React from 'react'

const tradeComponent = () => {
  return (
    <div></div>
  )
}

export default tradeComponent